import store from "../store";
import get from "lodash/get";
import { mapState } from "vuex";

const parts = window.location.hostname.split(".");
parts.shift();
const domain = parts.join(".");

export default {
  install(Vue) {
    Vue.prototype.$config = new Vue({
      store,
      data() {
        return {
          domain
        };
      },
      computed: {
        ...mapState(["config"])
      },
      methods: {
        get(key) {
          return get(this.config, key);
        }
      }
    });
  }
};
